import { createReducer } from '@reduxjs/toolkit';
import * as storageActions from 'store/amwell/storage/actions';
import { LoadableReducerStateValue } from 'store/amwell/types';
import { RESET_AMWELL_ACTIVITY } from '../actions';
import { Practice, PracticeCategory } from './types';
import * as actions from './actions';

export type PracticesState = Readonly<{
  list: {
    practices: Practice[];
    practiceCategories: PracticeCategory[];
    loading: boolean;
    error: Error | null;
  };
  details: LoadableReducerStateValue<Practice>;
  serviceKey: LoadableReducerStateValue<string>;
}>;

export const practicesInitialState: PracticesState = {
  list: {
    practices: [],
    practiceCategories: [],
    loading: false,
    error: null
  },
  details: {
    data: null,
    loading: false,
    error: null
  },
  serviceKey: {
    data: null,
    loading: false,
    error: null
  }
};

export const practicesReducer = createReducer(practicesInitialState, {
  [actions.GET_PRACTICES]: state => {
    state.list.loading = true;
    state.list.error = null;
  },
  [actions.GET_PRACTICES_FAIL]: (state, action) => {
    state.list.error = action.error;
    state.list.loading = false;
  },
  [actions.GET_PRACTICES_SUCCESS]: (state, action) => {
    state.list.practices = action.payload.practices;
    state.list.practiceCategories = action.payload.practiceCategories;
    state.list.loading = false;
  },
  [actions.UPDATE_PRACTICE]: state => {
    state.details.loading = true;
    state.details.error = null;
  },
  [actions.UPDATE_PRACTICE_FAIL]: (state, action) => {
    state.details.error = action.error;
    state.details.loading = false;
  },
  [actions.UPDATE_PRACTICE_SUCCESS]: (state, action) => {
    state.details.data = action.payload;
    state.details.loading = false;
  },
  [actions.ADD_SERVICE_KEY]: state => {
    state.serviceKey.loading = true;
    state.serviceKey.error = null;
  },
  [actions.ADD_SERVICE_KEY_FAIL]: (state, action) => {
    state.serviceKey.error = action.error;
    state.serviceKey.loading = false;
  },
  [actions.ADD_SERVICE_KEY_SUCCESS]: (state, action) => {
    state.serviceKey.data = action.payload;
    state.serviceKey.loading = false;
  },
  // Web Amwell Session Restore
  [storageActions.GET_STORAGE_SUCCESS]: (state, action) => {
    state.details.data = action.payload.practice;
  },
  [RESET_AMWELL_ACTIVITY]: () => practicesInitialState
});
